<div class="workbench" ui-view="workbench"></div>
